module.exports = __webpack_public_path__ + "img/o7.279732e6.png";